import { sizes } from '@bnnvara/breakpoints';
import { BaseButton } from '@bnnvara/buttons';
import { lowQualityImageSrc } from '@bnnvara/themes/constants';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const createMarkup = html => ({
  __html: html
});

const PropositionCard = ({
  thumbnail = {
    url: '',
    altText: ''
  },
  cta = {
    url: '',
    header: ''
  },
  title = null,
  description = null,
  onCTAClick = () => {}
}) => /*#__PURE__*/React.createElement(S.CardWrapper, null, thumbnail.url && /*#__PURE__*/React.createElement(S.CardImageContainer, null, /*#__PURE__*/React.createElement("source", {
  srcSet: thumbnail.url,
  media: `(min-width: ${sizes.lg}px)`
}), /*#__PURE__*/React.createElement(S.CardImage, {
  src: lowQualityImageSrc,
  alt: thumbnail.altText
})), /*#__PURE__*/React.createElement(S.CardBody, null, /*#__PURE__*/React.createElement("h2", null, title), description && /*#__PURE__*/React.createElement(S.Description, {
  dangerouslySetInnerHTML: createMarkup(description)
}), cta.header && /*#__PURE__*/React.createElement(S.ButtonMobile, null, /*#__PURE__*/React.createElement(BaseButton, {
  as: "a",
  variant: "red",
  type: "button",
  size: "small",
  href: cta.url,
  onClick: onCTAClick
}, cta.header))), cta.header && /*#__PURE__*/React.createElement(S.ButtonDesktop, null, /*#__PURE__*/React.createElement(BaseButton, {
  as: "a",
  variant: "red",
  type: "button",
  size: "small",
  href: cta.url,
  onClick: onCTAClick
}, cta.header)));

PropositionCard.propTypes = {
  thumbnail: PropTypes.shape({
    altText: PropTypes.string,
    src: PropTypes.string
  }),
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  cta: PropTypes.shape({
    header: PropTypes.string,
    url: PropTypes.string
  }),
  onCTAClick: PropTypes.func
};
export default PropositionCard;